import { both, type BoPage, page, simpleCms, withCr, withEshop } from "./model";

/** Pages du CMS simple (masquées quand le site est en CMS avancé seul). */
export const CMS_PAGES: BoPage[] = [
  page("cmsHome", "Accueil du site", "/cms", "globe", "website", simpleCms),
  page(
    "cmsGeneralSettings",
    "Paramètres généraux du site",
    "/cms/general-settings",
    "settings",
    "website",
    simpleCms,
  ),
  page(
    "cmsAppearance",
    "Apparence du site",
    "/cms/apparence",
    "globe",
    "website",
    simpleCms,
  ),
  page(
    "cmsMaintenance",
    "Maintenance du site",
    "/cms/maintenance",
    "settings",
    "website",
    simpleCms,
  ),
  page(
    "cmsArtist",
    "Page artiste",
    "/cms/artiste",
    "globe",
    "website",
    simpleCms,
  ),
  page(
    "cmsSelection",
    "Sélections d’œuvres",
    "/cms/selection",
    "bookmark",
    "website",
    simpleCms,
  ),
  page(
    "cmsNews",
    "Actualités du site",
    "/cms/news",
    "file-plus",
    "website",
    simpleCms,
  ),
  page(
    "cmsExpertise",
    "Page expertise",
    "/cms/expertise",
    "globe",
    "website",
    simpleCms,
  ),
  page(
    "cmsArtworkAuthentication",
    "Formulaire d’authentification d’œuvre",
    "/cms/artwork-authentication",
    "shield-check",
    "website",
    simpleCms,
  ),
  page(
    "cmsAbout",
    "Page à propos",
    "/cms/about-us",
    "globe",
    "website",
    simpleCms,
  ),
  page(
    "cmsContact",
    "Page contact",
    "/cms/contact",
    "globe",
    "website",
    simpleCms,
  ),
  page(
    "cmsPolicies",
    "Pages légales",
    "/cms/policies",
    "file-text",
    "website",
    simpleCms,
  ),
  page(
    "cmsCatalogue",
    "Catalogue raisonné du site",
    "/cms/catalogue-raisonne",
    "book",
    "website",
    both(simpleCms, withCr),
  ),
  page(
    "cmsAuthentication",
    "Espace authentification du site",
    "/cms/authentification",
    "shield-check",
    "website",
    both(simpleCms, (ctx) => !ctx.hideCr || ctx.haveEshop),
  ),
  page(
    "cmsEshop",
    "Articles de l’e-shop",
    "/cms/e-shop",
    "shopping-cart",
    "website",
    both(simpleCms, withEshop),
  ),
];
